import React, { useState } from "react";

import { Button, Tooltip } from "@mui/material";

import "./style.scss";

const imageFilter = require("Assets/img/filter-icon.svg");

interface ITableOutlineFilterButton {
  onClickHandler?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  label?: string;
  tooltip?: string;
  imageIcon?: string;
  countNumber: number | 0;
}
const TableOutlineFilterButton = (props: ITableOutlineFilterButton) => {
  const [openTooltip, setOpenTooltip] = useState<boolean>(false);

  return (
    <div className="table-outline-btn">
      <Tooltip
        open={props?.tooltip ? openTooltip : false}
        title={props?.tooltip || false}
        placement="top"
      >
        <Button
          onClick={props?.onClickHandler}
          onMouseEnter={() => setOpenTooltip(true)}
          onMouseLeave={() => setOpenTooltip(false)}
        >
          <div
            className="d-flex ml-2 align-items-center"
            style={{
              gap: "8px",
            }}
          >
            <img src={props?.imageIcon || imageFilter} />
            <div>{props?.label}</div>
            {props?.countNumber > 0 && (
              <div
                style={{
                  display: "flex",
                  width: "16px",
                  height: "16px",
                  padding: "10px",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "10px",
                  borderRadius: "100px",
                  background: "#0055A4",
                  color: "white",
                  fontFamily: "Manrope",
                  fontSize: "12px",
                  fontStyle: "normal",
                  fontWeight: "700",
                  lineHeight: "12px",
                }}
              >
                {props?.countNumber}
              </div>
            )}
          </div>
        </Button>
      </Tooltip>
    </div>
  );
};

export default TableOutlineFilterButton;
